/**
 * BulkUploadState - tiny state machine for Bulk Upload UI
 */

export const BulkUploadStates = {
  IDLE: 'idle',
  READING: 'reading',
  AI_ENHANCING: 'aiEnhancing',
  PREVIEW: 'preview',
  DUPLICATE_CHECK: 'duplicateCheck',
  IMPORTING: 'importing',
  COMPLETE: 'complete'
};

const transitions = {
  [BulkUploadStates.IDLE]: [BulkUploadStates.READING],
  [BulkUploadStates.READING]: [BulkUploadStates.AI_ENHANCING, BulkUploadStates.IDLE],
  [BulkUploadStates.AI_ENHANCING]: [BulkUploadStates.PREVIEW, BulkUploadStates.IDLE],
  [BulkUploadStates.PREVIEW]: [BulkUploadStates.DUPLICATE_CHECK, BulkUploadStates.IMPORTING, BulkUploadStates.IDLE],
  [BulkUploadStates.DUPLICATE_CHECK]: [BulkUploadStates.IMPORTING, BulkUploadStates.PREVIEW],
  [BulkUploadStates.IMPORTING]: [BulkUploadStates.COMPLETE, BulkUploadStates.PREVIEW],
  [BulkUploadStates.COMPLETE]: [BulkUploadStates.IDLE, BulkUploadStates.PREVIEW]
};

export function canTransition(from, to) {
  return (transitions[from] || []).includes(to);
}

export function createBulkUploadStateMachine(initial = BulkUploadStates.IDLE) {
  let state = initial;
  return {
    getState: () => state,
    setState: (next) => {
      if (!canTransition(state, next)) {
        return { ok: false, from: state, to: next };
      }
      state = next;
      return { ok: true, state };
    }
  };
}

